import { useIntl } from 'react-intl';
import { useFeesBySolutionContext } from 'sonata-platform-components';
import { Checkbox, IconTooltip, Selector, type SelectorOptionPropsInterface } from 'sonata-react-components';

import { ReuseIOConfigurationStyled } from './ReuseIOConfiguration.styled';

function ReuseIOConfiguration() {
  const { formatMessage } = useIntl();

  const { options, setOptions } = useFeesBySolutionContext();

  const numberOfEntitiesToCreateOptions = Array.from({ length: 99 }, (_, i) => i + 2).map(num => ({
    id: String(num),
    label: String(num),
    value: String(num)
  }));

  const handleChangeNumberOfLineItems = ({ value }: SelectorOptionPropsInterface) => {
    setOptions({
      ...options,
      numberOfEntitiesToCreate: parseInt(value as string, 10)
    });
  };

  return (
    <ReuseIOConfigurationStyled
      className="createCampaignReuseIOConfiguration"
      data-testid={'feesBySolutionReuseIOConfiguration'}
    >
      <div className="createCampaignReuseIOConfiguration__options">
        <Checkbox
          active={options.inheritMapConfigFromIO}
          classes="iabSelector__optionsSwitch"
          id="campaignCopyMapConfigurationCheckbox"
          labelText={formatMessage({
            defaultMessage: 'Copy map configuration (locations, venues, screens, etc).',
            id: 'multiFlightLineItem.options.inheritMapConfigFromIO'
          })}
          onClickAction={() =>
            setOptions({
              ...options,
              inheritMapConfigFromIO: !options.inheritMapConfigFromIO
            })
          }
        />
        <Checkbox
          active={options.inheritCreativeConfigFromIO}
          classes="iabSelector__optionsSwitch"
          id="campaignCopyAdsConfigurationCheckbox"
          labelText={formatMessage({
            defaultMessage: 'Copy ads configuration (ads already configured in the IO).',
            id: 'multiFlightLineItem.options.inheritCreativeConfigFromIO'
          })}
          onClickAction={() =>
            setOptions({
              ...options,
              inheritCreativeConfigFromIO: !options.inheritCreativeConfigFromIO
            })
          }
        />
      </div>
      <div className="createCampaignReuseIOConfiguration__bulkCreation">
        <div className="createCampaignReuseIOConfiguration__bulkCreationEnable">
          <Checkbox
            active={options.numberOfEntitiesToCreate >= 2}
            id="lineItemsInBulkSwitch"
            labelText={formatMessage({
              defaultMessage: 'Line Items in Bulk',
              id: 'multiFlightLineItem.bulkCreation.title'
            })}
            onClickAction={() =>
              setOptions({
                ...options,
                numberOfEntitiesToCreate: options.numberOfEntitiesToCreate >= 2 ? 1 : 2
              })
            }
            type="switch"
          />
          <IconTooltip
            effect="solid"
            event="mouseenter"
            icon="fa-regular fa-circle-info"
            iconColor="var(--color-sonata-primary-500, #7B9FE1) !important"
            place="top"
          >
            {formatMessage({
              defaultMessage: 'Enable this option in order to create two or more line items at the same time.',
              id: 'multiFlightLineItem.bulkCreation.tooltip'
            })}
          </IconTooltip>
        </div>
        {options.numberOfEntitiesToCreate >= 2 && (
          <>
            <label className="createCampaignReuseIOConfiguration__bulkCreationSubtitle">
              {formatMessage({
                defaultMessage: `Increase the number to create more Line Items
                  They’ll be numbered automatically (e.g., "Line Item - 1", "Line Item - 2", "Line Item - 3").`,
                id: 'multiFlightLineItem.bulkCreation.asterisk'
              })}
            </label>
            <Selector
              className="createCampaignReuseIOConfiguration__bulkCreationSelectorsItem"
              id="numberOfEntitiesToCreateSelector"
              label={formatMessage({
                defaultMessage: 'Line item quantity*',
                id: 'multiFlightLineItem.bulkCreation.label'
              })}
              onChange={handleChangeNumberOfLineItems}
              options={numberOfEntitiesToCreateOptions}
              type="simple"
              value={[
                numberOfEntitiesToCreateOptions.find(
                  item => parseInt(item.value, 10) === options.numberOfEntitiesToCreate
                ) || numberOfEntitiesToCreateOptions[0]
              ]}
            />
          </>
        )}
      </div>
    </ReuseIOConfigurationStyled>
  );
}

export default ReuseIOConfiguration;
